import { AddonStepGuideData, AddonStepGuideSettingsData } from '@/components/addons/stepguide/Data';
import AddonModel from '@/models/grid/AddonModel';
import { AdvancedAddonsStyleData } from '@/typings/interfaces/data/settings/settings';
import { AddonModelState } from '@/typings/interfaces/state/Addon';
import { StepGuideAlignmentEnum, StepGuideSizeEnum, StepGuideTypeEnum } from './Types';
import store from '@/store';

export interface AddonStepGuideState extends AddonModelState {
  settings: AddonStepGuideSettingsState;
}
export interface AddonStepGuideSettingsState {
  size: StepGuideSizeEnum;
  process: AddonStepGuideProcess;
  width?: string;
  alignment: StepGuideAlignmentEnum;
  advanced?: AdvancedAddonsStyleData;
}

export interface AddonStepGuideProcess {
  type: StepGuideTypeEnum;
  shouldCalculateQuestion?: boolean;
  backgroundColor?: string;
  color?: string;
  fillCircles?: boolean;
  fontColor?: string;
}

export class AddonStepGuideModel extends AddonModel<AddonStepGuideData, AddonStepGuideState> {
  parseAddon(data: AddonStepGuideData) {
    const state = this.state;

    state.settings = AddonStepGuideModel.contructSettingsState(data.settings);
  }

  private static contructSettingsState(data: AddonStepGuideSettingsData): AddonStepGuideSettingsState {
    let stepSize: StepGuideSizeEnum | undefined;
    switch (data.size) {
      case 'small':
        stepSize = StepGuideSizeEnum.SMALL;
        break;
      case 'big':
        stepSize = StepGuideSizeEnum.LARGE;
        break;

      default:
        stepSize = StepGuideSizeEnum.MEDIUM;
        break;
    }

    let alignment: StepGuideAlignmentEnum | undefined;

    switch (data.alignment) {
      case 'left':
        alignment = StepGuideAlignmentEnum.LEFT;
        break;
      case 'right':
        alignment = StepGuideAlignmentEnum.RIGHT;
        break;

      default:
        alignment = StepGuideAlignmentEnum.CENTER;
        break;
    }

    let processType: StepGuideTypeEnum | undefined;

    switch (data.progress_type) {
      case 'top_bar':
        processType = StepGuideTypeEnum.TOP_BAR;
        break;
      case 'step':
        processType = StepGuideTypeEnum.STEP;
        break;
      case 'percent':
        processType = StepGuideTypeEnum.PERCENTAGE;
        break;

      default:
        processType = StepGuideTypeEnum.CIRCLES;
        break;
    }

    return {
      size: stepSize,
      ...(data.width && { width: data.width }),
      alignment: alignment,
      process: {
        type: processType,
        shouldCalculateQuestion: data.progress_only_calc_questions === '1',
        fillCircles: data.fill_circles === '1',
        ...(data.progress_background_color && { backgroundColor: data.progress_background_color }),
        ...(data.progress_color && { color: data.progress_color }),
        ...(data.progress_font_color && { fontColor: data.progress_font_color })
      }
    };
  }

  public isAddonValid(): boolean {
    return !!store.getters['gamesteps/totalSteps'];
  }

  authorSignature(): string {
    return 'Jannik Fischer';
  }
}
